import CloudKitchenChapter from "@/components/CloudKitchenChapter";
import ClosingCTA from "@/components/ClosingCTA";

export default function CloudKitchen() {
  return (
    <main data-testid="cloud-kitchen-page" className="pt-16">
      <CloudKitchenChapter />
      <ClosingCTA />
    </main>
  );
}
